<template>
    <ValidationObserver
        class="needs-validation form-custom-format"
        v-bind:class="{'was-validated': validated}"
        tag="form"
        ref="observer"
        v-slot="{passes}"
        @submit.prevent="onSubmitForm"
    >
        <el-dialog
            :modal="true"
            ref="window"
            :fullscreen="true"
            :title="'Create Product'"
            :visible.sync="syncModal"
            :close-on-click-modal="false"
            :modal-append-to-body="true"
            :append-to-body="true"
            class="text-left bulk-create-dialog"
            :formStatus="formStatus"
            @dialog-state="dialogState"
            :group="group"
            :showClose="!processing"
        >

            <div ref="spreadsheet"></div>
            <template #footer>
                <div class="d-flex">
                    <template v-if="formLoading">
                        <mdb-btn color="elegant" size="sm" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </mdb-btn>
                    </template>
                    <template v-else>
                        <template v-if="formStatus == 'create'">
                            <template v-if="processing == true">
                                <mdb-btn color="elegant" size="sm" disabled>
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Processing...
                                </mdb-btn>
                            </template>
                            <template v-else>
                                <template v-if="formData != null && formData.hasOwnProperty('id') && formData.id !== null">
                                    <mdb-btn color="elegant" size="sm" @click="passes(onSubmitPrint)">
                                        <i class="el-icon-check text-white cursor-pointer"></i> Print
                                    </mdb-btn>
                                </template>
                                <template v-else>
                                    <mdb-btn color="elegant" size="sm" @click="passes(onSubmitForm)">
                                        <i class="el-icon-check text-white cursor-pointer"></i> Print
                                    </mdb-btn>
                                </template>
                            
                            </template>
                            <mdb-btn color="grey" size="sm" @click="passes(clearForm)">
                                <i class="el-icon-copy-document text-white cursor-pointer"></i> Clear
                            </mdb-btn>
                        </template>
                        <mdb-btn color="grey" size="sm" @click="closeDialog">
                            <i class="el-icon-close text-white cursor-pointer"></i> Close
                        </mdb-btn>
                    </template>
                </div>
            </template>
        </el-dialog>
    </ValidationObserver>
</template>
<script>
import { mdbBtn} from "mdbvue";
import {ValidationObserver} from "vee-validate";
import { mapActions,mapGetters } from 'vuex'

import jspreadsheet from '../../jsexcel/jexcel'
import { MessageBox, Message } from "element-ui";

export default {
    components: { 
        mdbBtn,
        ValidationObserver,
    },
    props : {
        group : {
            type : Number,
            default : 1
        },
    },

    inject:[],
    data : () => ({
        syncModal : false,
        validated: false,
        formStatus : "select",
        form : null,
        formData:null,
        formDataOrginal : null,
        formLoading : false,
        processing : false,
        showError : false,
        group2 : 3,
        spreadsheet: null,
        exportTableOptions : {
            download : false,
            allowDeleteColumn : false,
            allowRenameColumn : false,
            allowInsertColumn : false,
            defaultColAlign : 'left',
            csvHeader:true,
            tableWidth : '100%',
            tableHeight : 'calc(100vh - 85px)',
            tableOverflow : true,
            data:[[]],
            minDimensions:[3,50],
            onCopy : null,
            selectionCopy : false,
            allowCopy : true,
            columns: [],

            contextMenu: function(obj, x, y, e) {

                return false;
            }
        },

        isIndeterminate: false,
        checkAll: true,
        checkedOptions: [],
        checkboxOptions : [],
        postedData : [],
        unit_of_measurements : [],



    }),

    mounted() {
        const self = this;
        self.getUnitOfMeasurements().then(response => {
            self.unit_of_measurements = response.map(e => {
                return {
                    label : `${e.AbsEntry} - ${e.Name}`,
                    code : e.AbsEntry
                }
            },[])
        })
    },
    methods: {
        ...mapActions('UnitOfMeasurementModule',['getUnitOfMeasurements']),
        ...mapActions('PrintDatamatrixModule',['storeRecord']),
        createPopupTable(exportTableOptions){
            this.spreadsheet = jspreadsheet(this.$refs.spreadsheet, exportTableOptions);
            Object.assign(this, this.spreadsheet);
            this.spreadsheet.setData([])
        },

        async recreateSpreadsheet(){
            await this.spreadsheet.destroy();
        },
        /* start */



        /* end */

        openDialog(){
            this.syncModal = true
            this.formResetter();
            this.formStatus = 'select'
            /* */
        },
        closeDialog(){
            this.syncModal = false
            this.formResetter();
        },

        onSubmitCopyTemplate(){
            const self = this;

            const selectedColumns = this.checkboxOptions.filter((item) => {
                return self.checkedOptions.includes(item)
            },[])

            var txt = "Series\t";
            if(selectedColumns.length > 0){
                selectedColumns.forEach(element => {
                    txt += element.label+"\t"
                });
                txt += "\n"
            }

            var dummy = document.createElement("textarea");
            document.body.appendChild(dummy);
            dummy.setAttribute("id", "dummy_id");
            document.getElementById("dummy_id").value=txt;
            dummy.select();
            document.execCommand("copy");
            document.body.removeChild(dummy);

            Message.success({
                message: "Copied!"
            });
        },

        onSubmitSelectForm() {
            const self = this;

            this.formResetter();

            this.formStatus = 'create';
            const tableCols = this.checkboxOptions.filter((obj) => {
                return this.checkedOptions.includes(obj.value)
            },[]).map((obj) => {
                return {
                    type: obj.type,
                    width: obj.width,
                    title: obj.label,
                    name: obj.value,
                    readOnly: false,
                };
            });

            const finalColumns = [
                { type: 'text', width: '200px', title: 'ITEM CODE', name: 'series', readOnly: false, primaryKey: false },
                { type: 'text', width: '200px', title: 'UPC CODE', name: 'upc_code', readOnly: false, primaryKey: false },
                { type: 'text', width: '200px', title: 'BATCH NUMBER', name: 'batch_number', readOnly: false, primaryKey: false },
                ...tableCols,
            ];

            this.$nextTick(() => {
                const width = this.$refs.window.width;
                this.exportTableOptions.tableWidth = "100%";
                this.exportTableOptions.columns = finalColumns;
                this.createPopupTable(this.exportTableOptions);
            });
        },

        onSubmitBack(){
            const self = this;
            MessageBox.confirm('Are you sure you want to go back?', 'Warning', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning'
            }).then(() => {

                self.formStatus = 'select';
                self.form = self.formVar()
                requestAnimationFrame(() => {
                    self.$refs.observer.reset();
                });
                self.validated = false
                self.formLoading = false
                if(self.spreadsheet){
                    self.spreadsheet.destroy();
                }

            }).catch(() => {
                return
            });
        },

        onSubmitPrint(){
            const self = this;

            if(self.formData !== null && self.formData.id !== null){
                var strWindowFeatures = "location=yes,height=600,width=900,scrollbars=yes,status=yes";

                const win = window.open(`/barcode/print-data-matrix/${self.formData.id}`, "_blank", strWindowFeatures);
                    win.document.title = 'Print';
                    win.print()
            }
        },

        onSubmitForm() {
            const self = this;

            if (this.processing) {
                return false;
            }

            const tableData = this.spreadsheet.getJson();

            MessageBox.confirm('Warning: Are you sure you want to submit the data. Do you want to continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                if (tableData.length > 0) {
                    this.postCounter = 0;
                    this.dataLength = tableData.filter(item => item.series !== '').length;

                    if (this.dataLength > 0) {
                        const validData = tableData.filter(item => item.series !== '').map(item => {
                            return { ...item, completed: false };
                        });

                        if (validData.length === 0) {
                            self.$ThatsNotify.warning({
                                message: `Please fill up the series column.`,
                                timeOut: 10000
                            });
                            return false;
                        }

                        console.log('dataLength', validData);
                        self.formData = {items : validData}

                        console.log('formData', self.formData);
                        self.processing = true;

                        self.storeRecord({items : validData}).then(response => {
                                    console.log("response");
                                    // console.log(response);
                                    self.processing = false;

                                    self.formData = {...self.formData, ...response.data};
                                    self.formDataOrginal = {...self.formDataOrginal, ...response.data};
                                    self.onSubmitPrint()
                                }).catch(error => {
                                    console.log("error");
                                    console.log(error);
                                    self.processing = false;
                                });

                       /*  let chain = Promise.resolve();

                        chain.then(() => {
                          
                               
                            });

                            chain.finally(() => {
                                console.log('All records processed.');
                                this.processing = false;
                            }); */

                    }
                }
            }).catch((error) => {
                // Handle the case where the user cancels the confirmation dialog
                console.log('Confirmation dialog was cancelled.',error);
            });
        },


        formResetter(){
            this.form = this.formVar()
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
            this.validated = false
            this.formLoading = false
            this.processing = false
            this.setFormStatusCreate();

            if(this.spreadsheet){
                this.spreadsheet.destroy();
            }
        },

        dialogState(state){
            if(!state){
                this.formResetter();
                return
            }
            if(this.FormStatus == 'create'){
                this.formResetter();
            }

        },

        formVar(){
            return {
                date : null,
                items : [],
            }
        },
        setFormStatusCreate(){
            this.formStatus = 'create'
        },

        handleCheckAllChange(val) {
            this.checkedOptions = val ? this.checkboxOptions.map(i => i.value,[]) : [];
            this.isIndeterminate = false;
        },
        handleCheckedOptionsChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.checkboxOptions.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkboxOptions.length;
        },

        iterateAlphabetByNumber(numColumns) {
            const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            const columns = [];

            for (let i = 0; i < numColumns; i++) {
                let label = '';
                let index = i;
                while (index >= 0) {
                    label = alphabet[index % 26] + label;
                    index = Math.floor(index / 26) - 1;
                }

                columns.push(label);
            }
            return columns;
        },
        clearForm(){
            this.formData = this.formVar()
            this.formDataOrginal = this.formVar()
            this.recreateSpreadsheet();
            this.createPopupTable(this.exportTableOptions);
        },
    },

    computed: {
        ...mapGetters('InventoryItemMasterModule',{
            formRecord : 'formData',
            viewLoading : 'getLoading',
            postLoading : 'postLoading',
            
        }),

        isAllCompleted : function(){
            return (this.postedData.length > 0) ? this.postedData.every((item) => item.completed == true) : false;
        }
    },

    watch: {

    
        syncModal(val) {
            if (val && this.formStatus === 'select') {
                this.onSubmitSelectForm();
            }
        },
        isAllCompleted : function(value){
            if(value == true){
                this.processing = false;
                this.$emit('success');
            }
        }
    },


}
</script>

<style scoped>
.custom-checkbox .custom-control-label::before {
    border-radius: .50rem!important;cursor: pointer;
}

.no-image-gallery i.far {
    font-size: 42px;
    color: #959595;
}
.mdb-time-picker .clockpicker-span-hours,
.mdb-time-picker .clockpicker-span-minutes {
    color: #4285f4 !important;
}


</style>
